import { Box, Container, Typography } from "@mui/material";
import React from "react";
import meditationHero from "../../images/meditationHero.png";

const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 3,
    flexWrap: "wrap",
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight: 1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight: 600,
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const MeditationHero = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography
            variant="h4"
            textAlign={"start"}
            sx={{ ...styles.heroTitle }}
          >
          What is Meditation?
          </Typography>
          <Typography
            variant="body1"
            textAlign="start"
            sx={{ ...styles.heroSubtitle }}
          >
            Meditation is a practice where an individual uses a technique—such
            as focusing the mind on a particular object, thought, or activity—to
            train attention and awareness, and achieve a mentally clear and
            emotionally calm and stable state. It's often used to promote
            relaxation, stress reduction, and self-awareness.
          </Typography>
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box
            component="img"
            src={meditationHero}
            sx={{ width: "600px", heigh: "600px", }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default MeditationHero;
